module.exports = __webpack_public_path__ + "img/confetti_ball.5a69c181.gif";